import React, { Suspense } from 'react';

import withoutSSR from 'core/components/withoutSSR';

import { SimpleLoader } from 'core/components/Loader';

import modelPropTypes, {
  topicAttributes,
} from 'core/utils/prop-types/model';
import resolveRelationships from 'core/utils/relationships';

const PairCompare = React.lazy(() => import('./PairCompare'));
const Game = React.lazy(() => import('./Game'));

const relationships = resolveRelationships(['content'], {});


const compareMap = {
  pair_compare: PairCompare,
  game_compare: Game,
};

function GameCompare({ content }) {
  if (!content) return null;

  const topicType = content.attributes.topic_type;

  const CompareComponent = compareMap[topicType];

  const {
    content: {
      widgets,
    },
  } = relationships(content);

  return (
    <Suspense fallback={<SimpleLoader />}>
      <CompareComponent content={content} widget={widgets[0]} />
    </Suspense>
  );
}

GameCompare.propTypes = {
  content: modelPropTypes(topicAttributes),
};

export default withoutSSR(GameCompare);
